import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=285af944&scoped=true&"
import script from "./type1.vue?vue&type=script&lang=ts&"
export * from "./type1.vue?vue&type=script&lang=ts&"
import style0 from "./type1.vue?vue&type=style&index=0&id=285af944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285af944",
  null
  
)

export default component.exports